import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

export interface DialogProps {
  open: boolean;
  onChanged: (open: boolean) => void;
}

export default function DialogConditions({ open, onChanged }: DialogProps) {
  const { t } = useTranslation();

  const handleClose = () => {
    onChanged(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="sm"
      PaperProps={{
        component: "form",
      }}
    >
      <DialogTitle>{t("desc-conditions.title")}</DialogTitle>
      <DialogContent>
        <Typography>{parse(t("desc-conditions.list"))}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("common.close")}</Button>
      </DialogActions>
    </Dialog>
  );
}
